
import React, {useState} from 'react'

/* #3807: injury region 304 "Multiple" is loaded from the database but each
dropdown now selects a single injury, so it is never offered */
export const MULTIPLE_INJURY_REGION_ID = 304;

/**
 * Displays a select with options for all the different injury types
 * @param {Array} injuryTypes
 * @param {Integer} index
 * @param {function} onChange
 * @param {boolean} captureClaimNumber Show a Claim Number input for the selected region
 * @returns {undefined}
 */
const InjuryOptionList = ({injuryTypes, index, onChange, injuries, captureComments, captureClaimNumber}) => {

    const [selected, setSelected] = useState(0);
    const [comment,  setComment]  = useState('');
    const [claimNumber, setClaimNumber] = useState('');
    
    const items = 
        injuryTypes
        .filter( it => MULTIPLE_INJURY_REGION_ID !== it.pkRegionId )
        .filter( it => {
            
            const   isSel         = selected ===  it.pkRegionId;
            // does injuries include 'it'
            const   isInc         = injuries.reduce( ((accumulator, currentValue) => accumulator || (currentValue.pkRegionId === it.pkRegionId)), false );
            return  isSel || !isInc;
        })
        .map( it => <option key={it.pkRegionId} value={it.pkRegionId} >{it.NonMedicalRegion}</option>)
    
    const defaultitem =  <option key={0} value={0} >Select</option>
    
    const totItems = [defaultitem, ...items];
    
    const handleChange = e => {
        e.preventDefault()
        
        const newValue = { comment, claimNumber, pkRegionId: selected }
        if('comment' === e.target.name){
            newValue.comment = e.target.value;
            setComment(newValue.comment);
        }else if('claimNumber' === e.target.name){
            newValue.claimNumber = e.target.value;
            setClaimNumber(newValue.claimNumber);
        }else{
            const pkRegionId = Number.parseInt( e.target.value, 10 );
            setSelected( pkRegionId );
            newValue.pkRegionId = pkRegionId;
        }
        
        onChange( index, newValue );
    }
    
    const showComment = (captureComments && selected)? true: false;
    const showClaimNumber = (captureClaimNumber && selected)? true: false;

    const id = index + 1;

    return (
            <div>
            <div className="injury-areas__dropdown-holder">
                <label className="injury-areas__dropdown-label" htmlFor={'injury_select_'+id} >{id}</label>
                <div className="form__dropdown-wrapper">
                    <select 
                    id={'injury_select_'+id}
                    name='injuryID' value={selected} onChange={handleChange}  className="form__dropdown">{totItems}</select>
                </div>
            </div>
            {
                /* The API maps the Claim Number to the case Reference Type. maxLength
                18 means 3 values joined with ", " still fit the 60 character limit
                when a client's injuries aren't split into cases */
                showClaimNumber &&
                <div className='injury-areas__dropdown-holder' >
                    <label htmlFor={'injury_claim_number_'+id} >Claim Number</label>
                    <input className={'form__input'} type='text' id={'injury_claim_number_'+id}
                        name='claimNumber' maxLength={18} placeholder='Claim Number'
                        style={{clear: 'left'}} value={claimNumber} onChange={handleChange} />
                </div>
            }
            {
                showComment &&
                <div className='injury-areas__dropdown-holder' >
                    <textarea className={'form__input'} placeholder='Please add comments on this injury' 
                        style={{clear: 'left'}} value={comment} name='comment' onChange={handleChange} ></textarea>
                </div>
            }
        </div>
    )
}

export default InjuryOptionList